/**
 * Payment methods Stripe offers in only one shop, shown beside the card logos
 * there so the customer knows before they press pay.
 *
 * Polish shoppers look for BLIK first; a pay step that shows only Visa and
 * Mastercard reads as "card only" and they leave. The backend adds blik and
 * p24 to the Checkout Session only when the request language is pl
 * (stripe.service.ts, `isPolish`), and Stripe accepts them only in PLN, so
 * both have to hold here too. Showing BLIK where Stripe then does not offer it
 * would be worse than not showing it at all.
 *
 * Pure, so the rule is testable without a window, a router or a provider.
 */
export type LocalPaymentMark = "BLIK" | "Przelewy24";

export function localPaymentMarks(
  currency: string | null | undefined,
  locale: string | null | undefined,
): LocalPaymentMark[] {
  return currency?.toLowerCase().split("-")[0] === "pln" && locale === "pl"
    ? ["BLIK", "Przelewy24"]
    : [];
}

/**
 * The label of the online-payment radio on the delivery step: the plain card
 * label everywhere, and one that names the local methods where they exist.
 */
export function onlinePaymentLabelKey(
  currency: string | null | undefined,
  locale: string | null | undefined,
): "checkout.paymentOnline" | "checkout.paymentWithCard" {
  return localPaymentMarks(currency, locale).length > 0
    ? "checkout.paymentOnline"
    : "checkout.paymentWithCard";
}
